import "./LadingNaveBar.css";
import logo from "../../../assets/Images/seekbluelogostright.jpeg";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LadingNaveBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu on outside click
  useEffect(() => {
    const close = () => { setMenuOpen(false); setActiveItem(null); };
    if (menuOpen) document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [menuOpen]);

  const companyLinks = [
    { label: "About Us",   icon: "🏢" },
    { label: "Careers",    icon: "💼" },
    { label: "Blog",       icon: "📝" },
    { label: "Press",      icon: "📢" },
  ];

  const supportLinks = [
    { label: "Help Center",    icon: "🎯" },
    { label: "Documentation",  icon: "📚" },
    { label: "Contact Us",     icon: "💬" },
    { label: "System Status",  icon: "🟢" },
  ];

  return (
    <nav className={`lp-nav ${scrolled ? "lp-nav--scrolled" : ""}`}>
      <div className="lp-nav__inner">

        {/* Logo */}
        <Link to="/" className="lp-nav__logo">
          <img src={logo} alt="Seekk Logo" />
        </Link>

        {/* Desktop links */}
        <ul className="lp-nav__links">

          {/* Company dropdown */}
          <li
            className={`lp-nav__item lp-nav__item--dropdown ${activeItem === "company" ? "lp-nav__item--open" : ""}`}
            onMouseEnter={() => setActiveItem("company")}
            onMouseLeave={() => setActiveItem(null)}
          >
            <span className="lp-nav__link">
              Company
              <svg className="lp-nav__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
            <div className="lp-nav__dropdown">
              <div className="lp-nav__dropdown-inner">
                {companyLinks.map((item) => (
                  <a key={item.label} href="#" className="lp-nav__dropdown-item">
                    <span className="lp-nav__dropdown-icon">{item.icon}</span>
                    <span>{item.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </li>

          {/* Support dropdown */}
          <li
            className={`lp-nav__item lp-nav__item--dropdown ${activeItem === "support" ? "lp-nav__item--open" : ""}`}
            onMouseEnter={() => setActiveItem("support")}
            onMouseLeave={() => setActiveItem(null)}
          >
            <span className="lp-nav__link">
              Support
              <svg className="lp-nav__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
            <div className="lp-nav__dropdown">
              <div className="lp-nav__dropdown-inner">
                {supportLinks.map((item) => (
                  <a key={item.label} href="#" className="lp-nav__dropdown-item">
                    <span className="lp-nav__dropdown-icon">{item.icon}</span>
                    <span>{item.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </li>

          {/* Login */}
          <li className="lp-nav__item">
            <Link to="/login" className="lp-nav__link lp-nav__link--login">
              Login
            </Link>
          </li>

          {/* CTA */}
          <li className="lp-nav__item">
            <a href="#" className="lp-nav__cta">
              <span>Talk To an Expert</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </li>

        </ul>

        {/* Hamburger */}
        <button
          className={`lp-nav__hamburger ${menuOpen ? "lp-nav__hamburger--open" : ""}`}
          onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`lp-nav__mobile ${menuOpen ? "lp-nav__mobile--open" : ""}`}>
        <div className="lp-nav__mobile-section">
          <p className="lp-nav__mobile-label">Company</p>
          {companyLinks.map((item) => (
            <a key={item.label} href="#" className="lp-nav__mobile-item">
              <span>{item.icon}</span> {item.label}
            </a>
          ))}
        </div>
        <div className="lp-nav__mobile-section">
          <p className="lp-nav__mobile-label">Support</p>
          {supportLinks.map((item) => (
            <a key={item.label} href="#" className="lp-nav__mobile-item">
              <span>{item.icon}</span> {item.label}
            </a>
          ))}
        </div>
        <div className="lp-nav__mobile-actions">
          <Link to="/login" className="lp-nav__mobile-login">Login</Link>
          <a href="#" className="lp-nav__cta lp-nav__cta--full">
            Talk To an Expert
          </a>
        </div>
      </div>
    </nav>
  );
};

export default LadingNaveBar;
